/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowApplicationStepsControllerRemoveMutationResponse, WorkflowApplicationStepsControllerRemovePathParams, WorkflowApplicationStepsControllerRemove401, WorkflowApplicationStepsControllerRemove403, WorkflowApplicationStepsControllerRemove404 } from "../../models/workflowsController/WorkflowApplicationStepsControllerRemove";

function getWorkflowApplicationStepsControllerRemoveUrl(id: WorkflowApplicationStepsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/workflow-application-steps/${id}` as const }  
  return res
}

/**
 * @summary Soft-delete a workflow application step
 * {@link /api/v1/workflow-application-steps/:id}
 */
export async function workflowApplicationStepsControllerRemove(id: WorkflowApplicationStepsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<WorkflowApplicationStepsControllerRemoveMutationResponse, ResponseErrorConfig<WorkflowApplicationStepsControllerRemove401 | WorkflowApplicationStepsControllerRemove403 | WorkflowApplicationStepsControllerRemove404>, unknown>({ method : "DELETE", url : getWorkflowApplicationStepsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}